import { Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import UseResponsive from "@/utils/hooks/useResponsive";
import PATH from "@/config/PATH";
import failedImg from "@assets/web-v3-images/something-went-wrong.png";
import btnImg from "@assets/web-v3-images/btn-acc.png";

function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <UseResponsive>
      <div
        className="relative min-h-[100dvh] size-full flex flex-col items-center justify-center px-[8%]"
        style={{
          backgroundImage:
            "linear-gradient(rgb(252, 238, 210) 0%, rgb(253, 210, 156) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      >
        <img
          src={failedImg}
          alt="not-found"
          className="w-[47%]"
        />

        <Text
          as="p"
          className="text-[32px] font-bold text-center text-[rgba(113,59,18,1)] pt-6"
        >
          {t("not_found_page.title")}
        </Text>

        <Text
          as="p"
          className="text-[22px] text-center text-[#854A0E] pt-3"
        >
          {t("not_found_page.description")}
        </Text>

        <button
          type="button"
          className="relative w-full cursor-pointer btn-click-active max-w-[100%] mt-[6%] outline-none"
          onClick={() => navigate(PATH.HOME, { replace: true })}
        >
          <img src={btnImg} className="block w-full h-full" alt="Back to Home" />
          <Text
            className="absolute inset-0 flex items-center justify-center text-[29px] font-extrabold text-white"
            style={{
              WebkitTextStroke: "1px #FF692E",
              paintOrder: "stroke fill",
            }}
          >
            {t("not_found_page.back_home")}
          </Text>
        </button>
      </div>
    </UseResponsive>
  );
}

export default NotFound;
